import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  EmpRole,
  EmpRolePaginationApi,
  IsManagerApi,
} from 'src/app/shared/models/role/emp-role-mapping';
import {
  ApiEmpEvent,
  EmpEvent,
} from 'src/app/shared/models/setups/roles/roleEvent.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  constructor(private http: HttpClient) {}

  getRole(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/setups/role/get_role?limit=${data.limit}&page=${data.page}&role_name=${data.role_name}`
    );
  }

  editRoleStatus(stat, roleID): Observable<any> {
    const option = {
      status: stat,
      role_id: roleID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_role_status_action`,
      options
    );
  }

  editRole(roleID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/edit_role/` + roleID
    );
  }
  getMissingCount(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/missing-role-report`,
      req
    );
  }
  detailedMissingReport(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/detailed-missing-role-report`,
      req
    );
  }

  deleteRole(appId): Observable<any> {
    return this.http.post(`${environment.apiUrl}/setups/role/delete_role`, {
      role_id: appId,
    });
  }

  addRole(data: FormData, roleID): Observable<any> {
    if (!roleID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/add_role`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/edit_role_action`,
        data
      );
    }
  }

  getMenuRole(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/get_role_menus`,
      { params: param }
    );
  }

  editMenuRoleMapStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      map_id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_role_map_status_action`,
      options
    );
  }

  deleteMenuRoleMap(mapId): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/delete_role_mapping`,
      { map_id: mapId }
    );
  }

  addMenuRoleMap(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/add_role_menu_mapping`,
      data
    );
  }

  getEmpMenuRoleMap(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/get_emp_role_mapping`,
      { params: param }
    );
    // return this.http.get(`${environment.apiUrl}/setups/role/get_emp_role_mapping?page=${data.page}&limit=${data.limit}&emp_id=${data.emp_id}&role_id=${data.role_id}`);
  }

  editEmpMenuRoleMapStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      map_id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_emp_role_map_status_action`,
      options
    );
  }

  editEmpRole(roleID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/edit_emp_role_mapping/` + roleID
    );
  }

  deleteEmpMenuRoleMap(mapId): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/delete_emp_role_mapping`,
      { map_id: mapId }
    );
  }

  addEmpMenuRoleMap(data: FormData, mapID): Observable<any> {
    if (!mapID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/add_emp_role_mapping`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/edit_emp_role_mapping_action`,
        data
      );
    }
  }

  getEmpPlantRoleMap(): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/setups/role/get_emp_plant_mapping`
    );
  }

  editEmpPlantMapStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      map_id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_emp_plant_map_status_action`,
      options
    );
  }

  editPlantMapRole(plID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/edit_emp_plant_mapping/` + plID
    );
  }

  deleteEmpPlantRoleMap(mapId): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/delete_emp_plant_mapping`,
      { map_id: mapId }
    );
  }

  addEmpPlantRoleMap(data: FormData, mapID): Observable<any> {
    if (!mapID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/add_emp_plant_mapping`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/edit_emp_plant_mapping_action`,
        data
      );
    }
  }

  getEmpOrgRoleMap(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/setups/role/get_emp_org_mapping?page=${data.page}&limit=${data.limit}&empid=${data.empid}&org_id=${data.org_id}`
    );
  }

  editEmpOrgMapStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      map_id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_emp_org_map_status_action`,
      options
    );
  }

  editOrgMapRole(orgID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/edit_emp_org_mapping/` + orgID
    );
  }

  deleteEmpOrgMap(mapId): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/delete_emp_org_mapping`,
      { map_id: mapId }
    );
  }

  addEmpOrgRoleMap(data: FormData, mapID): Observable<any> {
    if (!mapID) {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/add_emp_org_mapping`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/setups/role/edit_emp_org_mapping_action`,
        data
      );
    }
  }
  getEmpPlants(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/get_emp_plants`,
      req
    );
  }
  activeEmpPlants(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/active_emp_plants`,
      req
    );
  }
  empPlantStatusAction(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/emp_plants_status_action`,
      req
    );
  }
  inActiveEmpPlants(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/inactive_emp_plants`,
      req
    );
  }
  deleteEmpPlants(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/delete_emp_plants`,
      req
    );
  }
  getPlantsForMappings(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/get_plants_for_mapping`,
      req
    );
  }
  addEmpPlantsMappings(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/add_emp_plants_mapping`,
      req
    );
  }

  // Event Mapping

  getEvents(smnuID, roleID): Observable<any[]> {
    return this.http.get<any>(
      `${environment.apiUrl}/select_event?smnu_id=${smnuID}&role_id=${roleID}`
    );
  }

  deleteEventRoleMap(eventID): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/delete_event_role`,
      { map_id: eventID }
    );
  }

  editEventRoleStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      map_id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/edit_event_role_status_action`,
      options
    );
  }

  addEventRoleMapping(data: FormData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/add_event_role_action`,
      data
    );
  }

  getMappedEvents(roleID, appID): Observable<any[]> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/get_event_role?role_id=${roleID}&app_id=${appID}`
    );
  }

  getRoleEvent(): Observable<EmpEvent[]> {
    return this.http
      .get<ApiEmpEvent>(`${environment.apiUrl}/get_emp_event`)
      .pipe(map((res) => res.data));
  }

  getEmpRole(): Observable<EmpRole[]> {
    return this.http
      .get<EmpRolePaginationApi>(
        `${environment.apiUrl}/setups/role/get_emp_role_mapping?self=self`
      )
      .pipe(map((res) => res.data.data));
  }

  getIsManager(): Observable<IsManagerApi> {
    return this.http.get<IsManagerApi>(
      `${environment.apiUrl}/setups/role/get_emp_role_manager?self=self`
    );
  }

  getRolesReport(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/get_roles_report`,
      req
    );
  }

  getRolesReportExcel(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/get_roles_report_export`,
      req
    );
  }
  uploadPcCodeRoles(req): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/import_pc_roles`,
      req
    );
  }
  getDefualtRoleMappings(): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/setups/role/get_default_role_map`
    );
  }

  deleteDirectMap(mapId): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/delete_direct_map`,
      { map_id: mapId }
    );
  }

  addDirectRoleMap(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/setups/role/add_direct_map`,
      data
    );
  }

  generateRoleCsv(data): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/setups/role/generateRoleCsv`,
      data
    );
  }
}
